import React, { useContext, useEffect } from 'react'
import {
    CCol,
    CContainer,
    CImage,
    CRow,
} from '@coreui/react-pro'
import { AppContext } from '../contexts/App'
import { Link } from 'react-router-dom'
import image404 from '../assets/0404Luxio.png'

export default function Page404() {
    const { setMetaData } = useContext(AppContext)

    useEffect(() => {
        setMetaData({
            title: "Page is not found",
        })
    }, [setMetaData])

    return (
        <div className="bg-light min-vh-100 d-flex flex-row">
            <CContainer lg>
                <CRow className="">
                    <CCol md={6}>
                        <div className="clearfix">
                            <CRow>
                                <CCol xs={12}>
                                    <CImage src={image404} width={100} />
                                </CCol>
                                <CCol xs={12}>
                                    <p className='display-6'>Wild <strong>#404</strong> appeared!</p>
                                    <p className="text-medium-emphasis ">
                                        The page you're looking for cannot be found. <br/><Link to={{pathname: '/'}}>Go back Home!</Link>
                                    </p>
                                </CCol>
                            </CRow>

                        </div>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    )
}